/** Window / service-worker event that opens a chat from a desktop notification. */
export const SENDBIRD_NOTIFICATION_CLICK = "SENDBIRD_NOTIFICATION_CLICK";
